import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { useStore } from '../store';
import { shared } from './shared';
import { WORLD } from '../config/zones';

// While sailing the central river in Boat mode, the Harpy Eagle delivers a
// one-time briefing on the 11th zone — the Neutral Channel of the unaligned.
export default function NeutralChannelGuide() {
  const acc = useRef(0);
  const dwell = useRef(0);
  const done = useRef(false);

  useFrame((_, delta) => {
    acc.current += delta;
    if (acc.current < 0.3) return;
    const step = acc.current;
    acc.current = 0;

    const s = useStore.getState();

    // Re-arm whenever we leave Boat mode, so each new voyage gets its welcome.
    if (!s.entered || s.mode !== 'boat') { done.current = false; dwell.current = 0; return; }
    if (done.current || s.tourActive || s.narrating) return;

    // Must be drifting the central channel (not up on a bank).
    if (Math.abs(shared.camPos.z) > WORLD.bankInner) { dwell.current = 0; return; }

    dwell.current += step;
    if (dwell.current < 1.4) return; // brief settle so it feels intentional

    done.current = true;
    s.narrateNeutral();
  });

  return null;
}
